import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 앞서 만든 json 파일들을 불러옵니다. (경로 확인 필수!)
import translationKR from './locales/kr.json';
import translationEN from './locales/en.json';
import translationJP from './locales/jp.json';
import translationCH from './locales/ch.json';

const resources = {
  KR: translationKR,
  EN: translationEN,
  JP: translationJP,
  CH: translationCH
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'KR', // 저장된 언어 없으면 KR
    fallbackLng: 'EN',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;